import { wrapWc } from 'brinejs/wrapper'
import '@ica-azure/ica-elements/IcaCheckbox'

type IcaCheckboxProps = React.JSX.IntrinsicElements['tgdb-ica-checkbox']

export const IcaCheckbox = wrapWc<IcaCheckboxProps>('tgdb-ica-checkbox', [])